import Box from "@material-ui/core/esm/Box";
import React from 'react';
import Spinner from 'components/Spinner/Spinner';
import { Header } from 'components/Text';
import useStyles from './LoadingPageStyles';
export default function LoadingPage() {
  const {
    loadingPageRoot
  } = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: loadingPageRoot
  }, /*#__PURE__*/React.createElement(Header, {
    align: "center"
  }, "Flyt"), /*#__PURE__*/React.createElement(Spinner, null));
}